var I18n = require('i18nline');
var extend = require('./dist/extensions/i18n_js');

module.exports = extend(I18n);
